import { Component, NgZone, Output, EventEmitter, Input, ElementRef, ViewChild, ViewContainerRef, ChangeDetectorRef, HostListener } from '@angular/core';
import { AlertController, Events, ToastController } from 'ionic-angular';
import { DriveServiceProvider } from '../../providers/drive-service/drive-service';
import { ConfigApiServiceProvider } from '../../providers/config-api-service/config-api-service';
import { ConfigureServiceProvider } from '../../providers/configure-service/configure-service';
import { CommunicationServiceProvider } from '../../providers/communication-service/communication-service'
declare var jQuery: any;
declare var epcConnect: any;
const DELIVERSTATUS = 2;
const RECEIVESTATUS = 3;
import * as saveAs from 'file-saver';

@Component({
  selector: 'version-history',
  templateUrl: 'version-history.html'
})
export class VersionHistoryComponent {
  @Output() cancelDeskHistory: EventEmitter<any> = new EventEmitter<any>();
  @Input() histroryStatus: any;
  @Input() templateId: any;
  @Input() params: any;
  @Output() closeTntActivity = new EventEmitter<any>();

  whichpage: any = 'activity';
  versiondata: any = [];
  def_quote_tans_id: any;
  versionResponseData: any;
  lestElem: any
  expandId: any
  lestElem1: any
  components: any;
  customParams: any = {};
  tempId: any;
  versionId: any;
  versionNo: any;
  documentId: any;
  user_id: any;
  paramId: any;
  deleteIdx: any = "";
  deleteDetailIdx: any = ""
  versionHeader: any;
  versionDetailData: any = [];
  defaultParam: any = { "start": 1, "end": 100, "userid": "3280", "rptname": "main_document_version415", "client": "HR88954" };
  versionHistoryPanelStatus: any = false;
  previousVersionIdx: any = "";
  postData: any;
  deskHistory: boolean = false;
  activityHistory: any = [];
  notes: any = '';
  showEditor: boolean = false;
  showInput: boolean = true;
  showUpload: boolean = false;
  record_id: any;
  time = new Date();
  importFile = ''
  emailId: any;
  userName: any;
  activityHistoryData: any = [];
  activityHistoryMessagedata: any = [];
  pullData: {};
  name = 'ng2-ckeditor';
  ckeConfig: any;
  footerSave: boolean = false;
  inputField: any;
  @Input() tntActiveStatus: any;
  @Input() templateID: any;
  @Input() recordId: any;
  @ViewChild('myckeditor', { read: ViewContainerRef, static: false }) ckeditor: ViewContainerRef;
  @ViewChild('scrollChat', { read: ViewContainerRef, static: false }) public myScrollContainer!: ElementRef;
  myFilesName: any = [];
  fileName: any;
  lastUserId: any;
  lastUserStatus: boolean = true;
  refreshStatus: boolean = false;
  broadcastSubs: any;
  constructor(public elem: ElementRef, public cdref: ChangeDetectorRef, public communicationServ: CommunicationServiceProvider, public configServiceProvider: ConfigureServiceProvider, public driveServiceProvider: DriveServiceProvider, public configApi: ConfigApiServiceProvider, public alertctrl: AlertController, private ngzone: NgZone, public events: Events, public toastController: ToastController, public driveService: DriveServiceProvider, public alertController: AlertController, public configureService: ConfigureServiceProvider, public configApiService: ConfigApiServiceProvider) {


    events.subscribe('reloadVersionHistory', (flag, params) => {
      if (flag) {
        this.customParams = params
        this.getApiData();
      }
    });

    events.subscribe('tabTrigger', (flag) => {
      this.events.publish('utilizationReport', true, this.configApi.driveApi)
      if (flag) {
        this.closeVersionHistoryPanel(flag);
        this.versiondata = [];
        this.versionDetailData = [];
      }
    });
    this.events.subscribe('versionHeaderName', (objCurrentFolder) => {
      this.versionHeader = objCurrentFolder;
    });

    this.broadcastSubs = this.communicationServ.getInstance()
      .subscribe((data: any) => {
        if (data.src === "grid-main") {
          if (data.event === 'updatedFormStatus') {
            let paramId = data['paramId'];
            let templateProperty = data['templateProperty'];
            if (this.versionHistoryPanelStatus == true) {
              this.templateId = templateProperty["id"];
              this.paramId = paramId;
              this.getApiData();
            } else {
              this.versiondata = [];
              this.versionDetailData = [];
            }
          }
        } else if (data.src === "versionProps") {
          if (data.event === 'updatedFormStatus') {
            let flag = data.status;
            let tempProperty = data.versionHistoryProps;
            this.versionHistoryPanelStatus = flag;
            if (flag === true) {
              if (!Array.isArray(tempProperty)) {
                this.templateId = tempProperty["templateProps"];
                let params = tempProperty["paramsData"];
                if (this.templateId.length > 0) {
                  if (params != "") {
                    let paramKey = [];
                    paramKey = Object.keys(params);
                    this.paramId = params[paramKey[0]]
                  } else {
                    this.paramId = params;
                  }
                  this.getApiData();
                } else {
                  this.versionDetailData = [];
                  this.versiondata = [];
                }
              }
            }

            this.events.subscribe('tabTriggerData', (status, screenProps, params, dataAccessType) => {
              this.versionDetailData = [];
              this.versiondata = [];
            })
          }
        }
      })

  }

  ngOnInit() {
    if (this.tntActiveStatus == true) {
      this.driveService.broadcastInfo({ src: 'drive', event: 'tntActiveStatus', status: true });
      this.templateId = this.templateID;
      this.record_id = this.recordId;
      this.pullTntActivity();
    }
    if (this.histroryStatus == "deskHistroyOPen") {
      this.deskHistory = true;
      this.loadTrackHistoryData();
    }
    let currentFolder = this.driveService.objCurrentFolder;
    this.versionHeader = this.driveService.objCurrentFolder["name"];
    this.emailId = this.driveService.objUserLoginDetails.email_id;
    if (this.emailId !== undefined) {
      this.userName = this.emailId.substring(0, this.emailId.lastIndexOf("@"));
    }
    this.ckeConfig = {
      editable: true,
      spellcheck: true,
      height: '15rem',
      minHeight: '5rem',
      placeholder: 'Enter text here...',
      translate: 'no',
      defaultParagraphSeparator: 'p',
      defaultFontName: 'Arial',
      toolbarHiddenButtons: [
        ['bold']
      ],
      customClasses: [
        {
          name: "quote",
          class: "quote",
        },
        {
          name: 'redText',
          class: 'redText'
        },
        {
          name: "titleText",
          class: "titleText",
          tag: "h1",
        },
      ]
    };
  }

  ngAfterViewChecked() {
    this.cdref.detectChanges();
  }
  /* * * * * *
    * ck Editor Events
    * * * * * */
  onCKEditorChange($event: any): void {
    this.footerSave = true;
  }

  onPaste($event: any): void {
  }

  onReady($event: any): void {
    var _this = this;
    $event.editor.on('contentDom', function () {
      var editable = $event.editor.editable();
      editable.attachListener(editable, 'dblclick', (event) => {
        jQuery("#bodyContainer").trigger("click");
        jQuery(".cdk-overlay-pane").css({ "top": (event.data["$"].screenY - 70), "left": (event.data["$"].screenX + 15) });
      })
      editable.attachListener(editable, 'contextmenu', (event) => {
        jQuery("#bodyContainer").trigger("click");
        jQuery(".cdk-overlay-pane").css({ "top": (event.data["$"].screenY - 70), "left": (event.data["$"].screenX + 15) });
      });
    });
  }

  onFocus($event: any): void {
  }

  loadTrackHistoryData() {
    if (this.templateId) {
      if (this.templateId.length > 0) {
        if (this.params != "") {
          let paramKey = [];
          paramKey = Object.keys(this.params);
          this.paramId = this.params[paramKey[0]]
        } else {
          this.paramId = this.params;
        }
        this.getApiData();
      } else {
        this.versionDetailData = [];
        this.versiondata = [];
      }
    }
  }

  expandItem(i, htmlNode) {
    if (this.expandId == i) {
      delete this.expandId;
    } else {
      this.expandId = i
    }
    jQuery(".innerhtml").html(htmlNode);
  }

  getApiData() {
    this.whichpage = 'activity'
    this.versiondata = [];
    let pullparams = {
      userid: this.configureService.getLoginUserID(),
      TemplateID: this.templateId,
      ParamId: this.paramId,
    }
    var objData = Object.assign({}, this.configApiService.driveApi.pullVersionHistory.params, pullparams)
    this.configApiService.pullRequest(objData, this.getSummary)
  }

  getSummary = ((data) => {
    if (data.length > 0) {
      if (data[0][0] == undefined || data[0][0] == "") {
        this.ngzone.run(() => {
          this.versiondata = data;
        });
      } else if (data[0][0].TemplateID != "") {
        this.ngzone.run(() => {
          this.versiondata = data;
        });
      }
    }
  });

  loadHistoryData(e, version, idx) {
    if (this.previousVersionIdx === '') {
      this.previousVersionIdx = idx;
      document.getElementById('fileCard_' + this.previousVersionIdx).style.textDecoration = "#488aff underline";
    } else {
      if (document.getElementById('fileCard_' + this.previousVersionIdx).style.textDecoration != null) {
        document.getElementById('fileCard_' + this.previousVersionIdx).style.textDecoration = "none";
        this.previousVersionIdx = idx;
        document.getElementById('fileCard_' + this.previousVersionIdx).style.textDecoration = "#488aff underline";
      }

    }

    if (version != "") {
      if (version.ScreenData != '') {
        let ScreenData = JSON.parse(version.ScreenData);
        if (ScreenData.length > 1) {
        } else {
          this.events.publish('enableDefaultFromNewButton', true);
        }
      }
    } else {
      const toast = this.toastController.create({
        message: "Invalied Data !!",
        duration: this.configApiService.toastDuration
      });
      toast.present();
    }
  }

  closeVersionHistoryPanel(flag) {
    this.cancelDeskHistory.emit(false);
    this.driveService.broadcastInfo({ src: 'drive', event: 'tntActiveStatusClose', status: false });
    // this.closeTntActivity.emit();
    this.driveService.broadcastInfo({ src: 'versionHistory', event: 'closeVersionHistoryPanel', status: flag });
  }

  fileTrash(_event, versionData, paramId, idx) {
    this.deleteIdx = idx;
    let alert = this.alertctrl.create({
      title: 'Are you sure, want to delete?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel'
        },
        {
          text: 'Ok',
          handler: data => {
            let postdataparams = {
              Delete: "True",
              ParamId: paramId,
              TemplateID: this.templateId,
              userid: this.configureService.getLoginUserID(),
              VersionNo: versionData
            }
            var objData = Object.assign({}, this.configApiService.driveApi.pushVersionHistory.params, postdataparams)
            this.configApiService.pushRequest(objData, this.submitSucess)
          }
        }
      ]
    });
    alert.present();
  }

  submitSucess = ((resData) => {
    this.versiondata.splice(this.deleteIdx, 1);
    const toast = this.toastController.create({
      message: 'File Deleted successfully !!',
      duration: this.configApiService.toastDuration,
      position: 'bottom'
    });
    toast.present();
  });

  deleteDocument() {
    let data = {};
    let Reg_UID = localStorage.getItem("epcdesk::REG_UID");
    data = {
      "document_id": this.documentId,
      "user_id": this.user_id,
      "attachments": "",
      "Comment": "",
      "version_name": "",
      "version_id": this.versionNo,
      "Delete": true,
      "userid": "3280",
      "rptname": "main_employeedocuments414",
      "client": "HR88954"
    }
    this.configApi.pushRequest(data, this.response_Data);
  }
  response_Data = ((data) => {
    const toast = this.toastController.create({
      message: "File Deleted successfully !!",
      duration: this.configApiService.toastDuration
    });

    toast.present();
    this.getApiData();
    this.clearData();
  });

  clearData() {
    jQuery(epcConnect).trigger("deleteTemplate");
  }
  onSegmentChanged(e) {
    if (this.templateId != undefined && this.paramId != undefined) {
      let pullparams = {
        userid: this.configureService.getLoginUserID(),
        TemplateID: this.templateId,
        RecordID: this.paramId,
      }
      var objData = Object.assign({}, this.configApiService.driveApi.pullshareinfo.params, pullparams)
      this.configApiService.pullRequest(objData, this.getDetailSummary)
    }
  }
  getDetailSummary = ((details) => {
    if (details) {
      this.versionDetailData = details;
    }
  })

  detailTrash(_event, ShareID, idx) {
    this.deleteDetailIdx = idx;
    let alert = this.alertctrl.create({
      title: 'Are you sure, want to delete?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel'
        },
        {
          text: 'Ok',
          handler: data => {
            let postdataparams = {
              "ShareID": ShareID,
              "Status": "delete",
              "userid": this.configureService.getLoginUserID(),
            }
            var objData = Object.assign({}, this.configApiService.driveApi.deleteShareinfo.params, postdataparams)
            this.configApiService.pushRequest(objData, this.submitDetail)
          }
        }
      ]
    });
    alert.present();
  }
  submitDetail = ((resData) => {
    this.versionDetailData.splice(this.deleteDetailIdx, 1);
    const toast = this.toastController.create({
      message: 'File Deleted successfully !!',
      duration: this.configApiService.toastDuration,
      position: 'bottom'
    });
    toast.present();
  });

  sendChatTnt() {
    this.activityHistoryData = []
    if (this.notes != '' || this.myFilesName.length > 0 && this.notes == '') {
      let actionStatus;
      if (this.lastUserId == undefined || this.lastUserId == this.configServiceProvider.getLoginUserID()) {
        actionStatus = this.lastUserStatus == true ? DELIVERSTATUS : RECEIVESTATUS;
      } else if (this.lastUserStatus == true && this.lastUserId != this.configServiceProvider.getLoginUserID()) {
        actionStatus = RECEIVESTATUS;
      } else if (this.lastUserStatus == false && this.lastUserId != this.configServiceProvider.getLoginUserID()) {
        actionStatus = DELIVERSTATUS;
      }
      let notifyJson = {
        "notes": this.notes,
        "attachment": this.myFilesName,
        "time": new Date(),
        "userName": this.userName,
        "userid": this.configServiceProvider.getLoginUserID(),
        "status": actionStatus == DELIVERSTATUS ? true : false
      };
      this.time = new Date();
      this.activityHistoryData.push(notifyJson);
      this.postData = {
        "client": this.driveServiceProvider.storeWrap.storeTemplates[this.templateId].pushParams.client,
        "userid": this.configServiceProvider.getLoginUserID(),
        "folderID": this.driveService.objCurrentFolder.folder_id,
        "templateID": this.templateId,
        "activityHistory": this.activityHistoryData,
        "recordID": this.record_id,
        "status": actionStatus,
        "usercode": this.driveService.longinUserName
      }
      let objPushTntData = Object.assign({}, this.configApiService.driveApi.pushTntActivity.params, this.postData);
      this.configApiService.customRequest(this.configApiService.pushTntActivityApi, objPushTntData, (resp) => {
        this.scrollToBottom();
        this.pullTntActivity();
        this.refreshStatus = true;
      });
      this.notes = '';
      this.showEditor = false;
      this.inputField = ''
      this.showUpload = false;
      this.myFilesName = [];
    }
  }
  pullTntActivity() {
    this.pullData = {
      "folderID": this.driveService.objCurrentFolder.folder_id,
      "userid": this.configServiceProvider.getLoginUserID(),
      "client": this.driveServiceProvider.storeWrap.storeTemplates[this.templateId].pushParams.client,
      "recordID": this.record_id,
      "templateID": this.templateId
    }
    this.scrollToBottom();
    let objPullTntData = Object.assign({}, this.configApiService.driveApi.pullTntActivity.params, this.pullData);
    this.configApiService.customRequest(this.configApiService.pullTntActivityApi, objPullTntData, (resp) => {
      this.activityHistory = []
      this.activityHistoryData = JSON.parse(resp._POST_PullTNTActivityResult)
      const dataLen = 0
      const objLen = 1;
      if (this.activityHistoryData.length > dataLen) {
        let lastIndex = this.activityHistoryData.length - objLen;
        let ObjActivityData = this.activityHistoryData[lastIndex].activityHistory;
        this.lastUserId = JSON.parse(ObjActivityData)[dataLen].userid;
        this.lastUserStatus = JSON.parse(ObjActivityData)[dataLen].status;
        if (this.refreshStatus == true) {
          this.driveService.broadcastInfo({ src: 'versionPanel', event: 'RefreshStatus', status: this.activityHistoryData[lastIndex] });
        }
      }
      this.activityHistoryData.forEach((element, i) => {
        var messagedata = JSON.parse(element.activityHistory)
        this.activityHistory.push(messagedata[dataLen])
      });
      console.log(this.activityHistory)
    });
  }
  getPosition() {
    let grid_holder = document.getElementById("input_field");
    let topPx = grid_holder.getBoundingClientRect().top;
    let topPosition = topPx - 200;
    return topPosition;
  }
  openEditor() {
    this.showEditor = !this.showEditor;
    this.showInput = !this.showInput;
    if (this.showEditor == true) {
      this.inputField = 'chat_inputField'
    } else {
      this.inputField = ''
    }
  }
  removeAttachedFile(idx) {
    this.myFilesName.splice(idx, 1);
  }
  handleKeyboardEvent(event) {
    this.sendChatTnt();
  }
  scrollToBottom(): void {
    try {
      this.myScrollContainer.nativeElement.scrollTop = this.myScrollContainer.nativeElement.scrollHeight;
    } catch (err) {
    }
  }
  @HostListener('document:click', ['$event.target'])
  public onClick(event) {
    const clickedInside = this.elem.nativeElement.contains(event);
    if (clickedInside == false) {
      const objLen = 0;
      if (event.classList[objLen] != 'fileRemove' && event.classList[objLen] != 'tntIcon') {
        this.driveService.broadcastInfo({ src: 'drive', event: 'tntActiveStatus', status: false });
        this.closeTntActivity.emit();
      }
    }
  }
  downloadFile(fileName) {
    console.log(fileName)
    this.fileName = fileName
    var body = { "fileName": fileName }
    this.configApiService.downloadFile(body, this.cbk);
  }
  public base64ToBlob(b64Data, contentType = '', sliceSize = 512) {
    b64Data = b64Data.replace(/\s/g, ''); //IE compatibility...
    let byteCharacters = atob(b64Data);
    let byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      let slice = byteCharacters.slice(offset, offset + sliceSize);
      let byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      let byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, { type: contentType });
  }

  cbk = ((resData) => {
    console.log(resData)
    this.downloadFileData(resData)
  })

  downloadFileData(b64encodedString: string) {
    if (b64encodedString) {
      var blob = this.base64ToBlob(b64encodedString, 'text/plain');
      saveAs(blob, this.fileName);
    }
  }
  uploadFile(event) {
    var formData = new FormData();
    formData.append("file", event.target.files[0])
    this.configApiService.uploadFile(formData, this.uploadFileResponse)
    this.myFilesName.push(event.target.files[0].name)
  }
  uploadFileResponse = ((resData) => {

  })

  ngOnDestroy() {
  }
}


// WEBPACK FOOTER //
// ./src/components/version-history/version-history.ts